import React from "react";
import style from "./Last.module.css";
function Last() {
  return (
    <div className={style.Last}>
      <h5>Self-Drive Car Rentals in Delhi NCR</h5>
      <p>
        From its rich culture to its buzzing nightlife, from delightful street
        food to shopping experiences, Delhi is truly the city that has
        everything. This constantly-evolving city hosts a massive road-length
        that is over 25,000 kilometres. With roads and highways that are
        well-maintained and ever-expanding, it comes as no surprise then, that
        the number of car rentals in Delhi has increased. These cars are quite
        economical and make travelling from one destination to the next, a
        smooth ride. Revv also offers self drive car rentals in Gurgaon and
        Noida.
      </p>
      <h5>Places to Go</h5>
      <p>
        Right from the moment you land at the Delhi airport, you can get a Revv
        self-drive car rental from the airport in Delhi. From here, you can head
        straight to your accommodation, or spend some time in Old Delhi,
        enjoying the sights and haggling at the bazaars. Since Revv cars come
        with affordable hourly rates, locals can use a Revv car rental Delhi to
        enjoy day-long drives in and around the city. We’d recommend a trip to
        Alwar to see the famous fort or the Siliserh Lake, or a delightful drive
        to Agra to witness the beauty of the mesmerising Taj Mahal. If you’re
        planning a longer trip, don’t worry. Revv has an attractive unlimited
        kilometre rental option that gives you the freedom to enjoy a long drive
        to Jaipur, Lucknow, Manali, Mussoorie, Kasol or any other destination
        that your heart desires.
      </p>

      <h5>Selecting a Car</h5>
      <p>
        Depending on whether you’re using your Revv car to zip in and out of
        city traffic or to cruise down highways, you can select a model that
        fits your needs. We offer everything from convenient hatchbacks like the
        Hyundai Grand i10 to roomy sedans like the Ford Aspire, Honda City &
        Nissan Sunny, and even tough SUVs like the Toyota Innova Crysta and
        Mahindra XUV.
      </p>
      <h5>Rent a car from Revv</h5>
      <p>
        Renting our self-drive cars in Delhi, Gurgaon or Noida is incredibly
        easy. All you need to do is:
      </p>

      <ul>
        <li>
          Download the Revv app from the Apple App Store or Google Play Store
        </li>
        <li>
          Select your preferred car and tell us when and where you need it{" "}
        </li>
        <li>
          {" "}
          Accept delivery of the car, which will happen at the agreed upon time
          and place
        </li>
        <li>
          {" "}
          Turn on the ignition and get ready for an amazing adventure
        </li>{" "}
        <li> Let us know where we can pick up the car from</li>{" "}
        <li>
          {" "}
          Receive an email invoice for your trip within 48 hours of the end of
          the journey
        </li>
        <li> Use the app to change or cancel your booking as required</li>
      </ul>

      <h5>The Revv Advantage</h5>
      <p>
        With flexible rental options and a wide network that’s visible across
        most cities in India, renting from Revv has become the preferred choice
        for most Delhi NCR locals. Our wide fleet of cars come with All India
        Tourist Permits, so you needn’t worry about crossing state borders while
        you journey across India’s roads. With Revv, renting a self-drive car is
        affordable, easy and absolutely hassle-free!
      </p>
    </div>
  );
}

export default Last;
